import { render, staticRenderFns } from "./TaxRateSetting.vue?vue&type=template&id=67477f66&"
import script from "./TaxRateSetting.vue?vue&type=script&lang=js&"
export * from "./TaxRateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports